import { Shield } from "lucide-react";

const Showcase = ({ t }) => {
  return (
    <section
      id="showcase"
      data-testid="showcase-section"
      className="relative bg-white py-24 sm:py-32 border-t border-[#0a192f]/10"
    >
      <div className="bid-container">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-start mb-12">
          <div className="lg:col-span-7">
            <p className="bid-overline text-[#d4af37] mb-4">{t.showcase.overline}</p>
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-display font-black text-[#0a192f] tracking-tight leading-tight"
              data-testid="showcase-title"
            >
              {t.showcase.title}
            </h2>
            <p className="mt-3 font-display text-xl sm:text-2xl text-[#1d3557] italic">
              {t.showcase.subtitle}
            </p>
            <p className="mt-5 text-base text-[#4a5568] leading-relaxed max-w-2xl">
              {t.showcase.description}
            </p>
          </div>

          <div className="lg:col-span-5 flex flex-wrap gap-2">
            {t.showcase.tags.map((tag, i) => (
              <span
                key={i}
                data-testid={`showcase-tag-${i}`}
                className="inline-flex items-center gap-2 bg-[#0a192f] text-white px-4 py-2 text-xs font-display font-bold uppercase tracking-wider"
              >
                <Shield className="w-3 h-3 text-[#d4af37]" />
                {tag}
              </span>
            ))}
          </div>
        </div>

        {/* Real BID showcase board */}
        <div
          className="relative border border-[#0a192f]/10 overflow-hidden bg-[#f8f9fa]"
          data-testid="showcase-board"
        >
          <img
            src="/showcase-nr12.jpg"
            alt="Proteção de Partes Móveis — aplicações reais BID"
            className="w-full h-auto block"
            loading="lazy"
          />
          {/* Decorative corner accent */}
          <div className="absolute top-0 right-0 w-24 h-24 sm:w-32 sm:h-32 bg-[#d4af37] opacity-0 pointer-events-none" />
        </div>

        <p className="mt-5 text-center text-xs text-[#4a5568] italic">
          Aplicações reais executadas pela equipe técnica BID — todas em conformidade com a NR12.
        </p>
      </div>
    </section>
  );
};

export default Showcase;
